import { Grid } from "@material-ui/core";
import Axios from "axios";
// import Axios from "axios";
import "date-fns/locale/pt-BR";
import React, { forwardRef, useImperativeHandle } from "react";
import config from "react-global-configuration";
import { toast } from "react-toastify";
import ClienteResumo from "../Cliente/ClienteResumo";
import PedidoResumo from "../Pedido/PedidoResumo";

const AceiteDadosConfirmacaoPedido = forwardRef((props, ref) => {
	useImperativeHandle(ref, () => ({
		advanceHandler() {
			return enviarPedido();
		},
	}));

	const enviarPedido = () => {
		props.setLoading(true);

		Axios.post(
			config.get("url_api") +
				"orcamento/salvar-dados-pedido/" +
				props.data.orcamento.id,
			props.pedidoTotvs
		)
			.then(function (response) {
				if (response.status === 200) {
					if (!response.data.success) {
						toast.error(response.data.mensagem);
						props.setLoading(false);
						return true;
					} else {
						props.setLoading(false);
						props.forceNext();
						return true;
					}
				} else {
					toast.error("Erro ao enviar dados.");
					props.setLoading(false);
					return true;
				}
			})
			.catch(function (error) {
				toast.error("Erro:" + error);
				props.setLoading(false);
			});
	};

	return (
		<React.Fragment>
			<Grid container spacing={3}>
				<Grid item md={12}>
					<ClienteResumo cliente={props.cliente} />
					<PedidoResumo pedido={props.pedidoTotvs} />
				</Grid>
			</Grid>
		</React.Fragment>
	);
});

export default AceiteDadosConfirmacaoPedido;
